<div class="chat-state chat-state--{{ state }}" *ngIf="state === 'error' || state === 'closed' || state === 'connecting'">
  <span>{{ stateLabel }}</span>
</div>
